import { z } from 'zod';

import { EmailSchema, JsonSchema } from '@vestigas/utils';

// `CompanyInvoiceCheckDelaySettings` in the OpenAPI spec — no `enabled` field
// exists there; that was never returned by the API, so reading it always got
// `undefined`.
const zodCompanyInvoiceCheckDelaySettingsSchema = z.object({
  delayedDays: z.number().nullish(),
  onlyIncludeWorkdays: z.boolean().nullish(),
});

// `PdfAiParsingSchema` in the OpenAPI spec. The only consumer of this field
// writes `null` to clear it and never reads the nested values, so the nested
// shape (a union of an AI-model list and legacy string, plus a free-form
// custom-settings object) is kept loose rather than fully modeled.
const zodPdfAiParsingSchema = z.object({
  customSettings: z.record(z.string(), JsonSchema).nullish(),
  defaultAiModel: JsonSchema.nullish(),
  defaultSenderAddresses: z.array(EmailSchema).nullish(),
  defaultSenderDomain: z.string().nullish(),
  environment: z.string().nullish(),
});

/**
 * Schema for validating company settings update request body
 * (`VAdminSettingsSchemaUpdate` in the OpenAPI spec).
 * @deprecated This endpoint is deprecated and shall be replaced by update_company_by_id.
 */
export const zodUpdateCompanySettingsBodySchema = z.object({
  allowedInvoiceSenderAddresses: z.array(EmailSchema).nullish(),
  delnoteSenderAddresses: z.array(EmailSchema).nullish(),
  // Company IDs, not email addresses, despite the name.
  directlySendInvoicesTo: z.array(z.uuid()).nullish(),
  domains: z.array(z.string()).nullish(),
  featureFlags: z.record(z.string(), z.boolean()).nullish(),
  invoiceChecking: zodCompanyInvoiceCheckDelaySettingsSchema.nullish(),
  pdfAiParsing: zodPdfAiParsingSchema.nullish(),
});

/**
 * What both the GET and the update endpoint return (`VAdminSettingsSchema` in
 * the OpenAPI spec). `vgsInvoiceMailboxAddresses` is read-only here: only the
 * invoice_mailbox endpoints may write it, so the update body leaves it out.
 * @deprecated This endpoint is deprecated and shall be replaced by update_company_by_id.
 */
export const zodCompanySettingsSchema =
  zodUpdateCompanySettingsBodySchema.extend({
    vgsInvoiceMailboxAddresses: z.array(EmailSchema).nullish(),
  });

export const zodUpdateCompanySettingsEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.uuid(),
  z.literal('vadmin_settings'),
]);
